/**
 * @fileoverview AddComponent modal for component pop up
 * @author  Lucas Sena
 */

import React, { PureComponent } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as Actions from "store/actions";
import Button from "components/elements/Button";
import ToggleButton from "components/input/ToggleButton";
import Spinner from "components/elements/Spinner";
import ModalAddComponent from "components/elements/ModalAddComponent";
import ModalAddMalfunction from "components/elements/ModalAddMalfunction";
import ModalDeleteComponent from "components/elements/ModalDeleteComponent";
import ModalEditComponent from "components/elements/ModalEditComponent";
import ModalDeleteMalfunction from "components/elements/ModalDeleteMalfunction";
import ModalEditMalfunction from "components/elements/ModalEditMalfunction";
import ModalWarning from "components/elements/ModalWarning";
import i18n from "i18n";
import css from "./Modal.module.scss"; // Import css modules stylesheet as styles

function actionModal(props) {
  const {
    message, primaryAction, actionText, style, close,
  } = props;
  return (
    <div className={[css.inner, css.action, css[style]].join(" ")}>
      <button onClick={close} className={[css.close, css[style]].join(" ")}>
        <span className="icon-close" />
      </button>
      <div className={css.title}>
        {style === "alert" && "Do you really want to publish?"}
        {style === "warning" && "Warning"}
        {style === "error" && "Are you sure?"}
      </div>
      <div className={css.message}>{message}</div>
      <div className={css.buttons}>
        <Button onClick={close} type="outlined">
          {i18n.t("global.cancel")}
        </Button>
        <Button
          onClick={() => {
            primaryAction();
          }}
          type="primary"
          color={style}
        >
          {actionText}
        </Button>
      </div>
    </div>
  );
}

function loadingModal(props) {
  const { message } = props;
  return (
    <div className={[css.inner, css.wait].join(" ")}>
      <Spinner className={css.spinner}>{message}</Spinner>
    </div>
  );
}

function settingsModal(props) {
  const {
    title,
    message,
    primaryAction,
    actionText,
    style,
    changeSettingAction,
    state,
    loading,
  } = props;
  return (
    <div className={[css.inner, css.settings, css[style]].join(" ")}>
      <div className={css.title}>{title}</div>
      <div className={css.message}>{message}</div>
      <ToggleButton
        className={css.toggleButton}
        checked={state}
        onChange={changeSettingAction}
      />
      <div className={css.buttons}>
        <Button
          onClick={() => {
            primaryAction();
          }}
          type="primary"
          color={style}
          className={css.wideButton}
          disabled={loading}
        >
          {actionText}
        </Button>
      </div>
    </div>
  );
}

function returnModalBody(props) {
  const { type } = props;
  switch (type) {
    case "ADD_COMPONENT": {
      return (
        <ModalAddComponent data={props} />
      );
    }
    case "EDIT_COMPONENT": {
      return (
        <ModalEditComponent data={props} />
      );
    }
    case "DELETE_COMPONENT": {
      return (
        <ModalDeleteComponent data={props} />
      );
    }
    case "ADD_MALFUNCTION": {
      return (
        <ModalAddMalfunction data={props} />
      );
    }
    case "EDIT_MALFUNCTION": {
      return (
        <ModalEditMalfunction data={props} />
      );
    }
    case "DELETE_MALFUNCTION": {
      return (
        <ModalDeleteMalfunction data={props} />
      );
    }
    case "API_WARNING": {
      return (
        <ModalWarning data={props} />
      );
    }
    default:
      return props;
  }
}

class ModalComponents extends PureComponent {
  componentDidMount() {
    const { modal, closeModal } = this.props;
    if (modal) {
      document.body.classList.add("no-scroll");
      const { type } = modal;

      if (type !== "wait") {
        document.addEventListener(
          "keydown",
          (event) => {
            const { key } = event;
            if (key === "Escape") {
              closeModal();
            }
          },
          { once: true },
        );
        if (!type) {
          document.body.classList.remove("no-scroll");
        }
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("no-scroll");
  }

  render() {
    const {
      modal, closeModal, state, loading,
    } = this.props;
    if (!modal.display) {
      return null;
    }
    return (
      <div className={css.container}>
        {modal.type === "wait" && loadingModal(modal)}
        {modal.type === "action"
          && actionModal({ ...modal, close: closeModal })}
        {modal.type === "settings"
          && settingsModal({
            ...modal,
            close: this.props,
            state,
            loading,
          })}
        {returnModalBody(modal)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { modal } = state.components;
  if (modal) {
    const { mapState } = modal;
    if (mapState) {
      return { ...mapState(state), modal: state.notifications.modal };
    }
  }
  return {
    modal: state.components.modal,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(Actions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalComponents);
